module.exports = __webpack_public_path__ + "img/key.c54698ce.png";